import { Box } from "@mui/system";
import { NO_CONTRACTS } from "./constants";
import styles from "./empty.module.css";
// import { ACTIVE_STATUS } from "../../constants";
export function EmptyContractsList() {
  return (
    <Box justifyContent="center" className={styles.emptyListContainer}>
      <img src="../../../assets/images/svg/emptyContracts.svg" />
      <p>{NO_CONTRACTS}</p>
    </Box>
  );
}
